var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"u-margin-top-8x"},[(_vm.hasError)?_c('BaseStateIndicator',{attrs:{"state":"error"}}):_c('BaseSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }